module.exports = __webpack_public_path__ + "img/11.ef00d70f.jpg";